import { Box, Grid, styled } from '@ltvco/refresh-lib/theme';

export const VehicleSearchFieldContainer = styled(Grid)(({ theme }) => ({
  height: '58px',
  display: 'flex',
  alignItems: 'center',
  border: `1px solid ${theme.palette.text.disabled}`,
  borderRadius: '32px',
  backgroundColor: theme.palette.background.paper,
  width: '100%',
  margin: theme.spacing(4, 0),

  '&:focus-within': {
    borderColor: theme.palette.primary.main,
  },

  '&.error': {
    borderColor: theme.palette.error.main,
  },

  [theme.breakpoints.down('sm')]: {
    margin: 0,
  },
}));

export const VehicleFormContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const IntegratedSearchContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  borderRadius: '32px',
  flexDirection: 'row',
  overflow: 'hidden',
  backgroundColor: theme.palette.common.white,
}));

export const StyledSelectInputContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  textAlign: 'right',

  '& .MuiFormControl-root': {
    width: '100%',
    borderLeft: `1px solid ${theme.palette.divider}`,

    [theme.breakpoints.down('sm')]: {
      borderLeft: 'none',
    },
  },

  '& .MuiOutlinedInput-root': {
    borderRadius: '0 32px 32px 0',
    textAlign: 'left',

    [theme.breakpoints.down('sm')]: {
      borderRadius: '32px',
    },
  },

  '& .MuiSelect-select': {
    backgroundColor: theme.palette.background.paper,

    [theme.breakpoints.down('sm')]: {
      borderRadius: '32px',
    },
  },
}));

export const VehicleInputsErrorTextPositionWrapper = styled(Box)(
  ({ theme }) => ({
    '& .error .MuiTypography-root': {
      left: '8px',

      [theme.breakpoints.down('sm')]: {
        left: '32px',
      },
    },
  })
);

export const YMMSelectInputWrapper = styled(Grid)(({ theme }) => ({
  borderLeft: `1px solid ${theme.palette.divider}`,

  '&.MuiGrid-item': {
    paddingLeft: 0,
  },
}));
